import React, { ReactNode } from 'react';

export type JLabelProps = {
  label: string | ReactNode;
};

export const JLabel: React.FC<JLabelProps> = ({ label }) => {
  return typeof label === 'string' ? (
    <div className="font-bold text-gray-dark uppercase">{label}</div>
  ) : (
    <>{label}</>
  );
};
